import { useState, useEffect, useMemo } from "react";
import { Search, BookUser } from "lucide-react";
import apiClient from "../../services/api";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

// Pick a shared contact → fills a job contact row. Phone: mobile if present, otherwise office.
export const pickedPhone = (c) => c.phone_mobile || c.phone_office || "";

const ContactPickerDialog = ({ open, onOpenChange, onPick }) => {
  const [contacts, setContacts] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!open) return;
    setQ("");
    apiClient.get("/shared-contacts").then((r) => setContacts(r.data)).catch(() => setContacts([]));
  }, [open]);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    return (s ? contacts.filter((c) => [c.display_name, c.company, c.title, c.email].some((v) => (v || "").toLowerCase().includes(s))) : contacts).slice(0, 50);
  }, [contacts, q]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="contact-picker-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><BookUser className="w-5 h-5" /> Pick from Contacts</DialogTitle></DialogHeader>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, company, email…" className="pl-9" data-testid="contact-picker-search" />
        </div>
        <div className="max-h-[50vh] overflow-auto divide-y rounded border" data-testid="contact-picker-list">
          {filtered.length === 0 && <p className="text-sm text-muted-foreground p-4 text-center">{contacts.length === 0 ? "No shared contacts yet." : "No matches."}</p>}
          {filtered.map((c) => (
            <button key={c.id} type="button" onClick={() => { onPick(c); onOpenChange(false); }} className="w-full text-left px-3 py-2 hover:bg-accent text-sm" data-testid={`contact-picker-item-${c.id}`}>
              <div className="font-medium">{c.display_name}</div>
              <div className="text-xs text-muted-foreground flex flex-wrap gap-x-3">
                {[c.title, c.company].filter(Boolean).join(" · ") && <span>{[c.title, c.company].filter(Boolean).join(" · ")}</span>}
                {pickedPhone(c) && <span>{pickedPhone(c)}</span>}
                {c.email && <span>{c.email}</span>}
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactPickerDialog;
